import { css } from 'styled-components';
import { breakpoint } from '../mixins/breakpoints';
import { spacing } from '../mixins/spacing';

export default css`
  .mb-xlarge {
    ${spacing('ExtraLarge', 'margin-bottom')}
  }
  .mb-large {
    ${spacing('Large', 'margin-bottom')}
  }
  .mb-medium {
    ${spacing('Medium', 'margin-bottom')}
  }
  .mb-small {
    ${spacing('Small', 'margin-bottom')}
  }
  .mb-xsmall {
    ${spacing('ExtraSmall', 'margin-bottom')}
  }
  .mb-none {
    ${spacing('None', 'margin-bottom')}
  }

  //margin top
  .mt-xlarge {
    ${spacing('ExtraLarge', 'margin-top')}
  }
  .mt-large {
    ${spacing('Large', 'margin-top')}
  }
  .mt-medium {
    ${spacing('Medium', 'margin-top')}
  }
  .mt-small {
    ${spacing('Small', 'margin-top')}
  }
  .mt-xsmall {
    ${spacing('ExtraSmall', 'margin-top')}
  }
  .mt-none {
    ${spacing('None', 'margin-top')}
  }

  // global margins
  .m-xlarge {
    ${spacing('ExtraLarge', 'margin')}
  }
  .m-large {
    ${spacing('Large', 'margin')}
  }
  .m-medium {
    ${spacing('Medium', 'margin')}
  }
  .m-small {
    ${spacing('Small', 'margin')}
  }
  .m-xsmall {
    ${spacing('ExtraSmall', 'margin')}
  }
  .m-none {
    ${spacing('None', 'margin')}
  }
  .m-auto {
    margin: auto;
  }
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
`;
